import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationCredentials as SchemaIntegrationCredentials } from '../schemas/IntegrationCredentials';
import { type IntegrationSystemType as SchemaIntegrationSystemType } from '../schemas/IntegrationSystemType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const UpdateIntegrationCredentialsContentType = 'application/json' as const;
export type UpdateIntegrationCredentialsRequest = SchemaIntegrationCredentials;
export type UpdateIntegrationCredentialsResponses = LinkCommonErrorResponses & {};
export type UpdateIntegrationCredentialsResponseSuccess = undefined;
export type UpdateIntegrationCredentialsSearchParams = undefined;
export type UpdateIntegrationCredentialsPathParameters = {
    type: SchemaIntegrationSystemType;
};
export const UpdateIntegrationCredentialsUrl = '/integrations/type/{type}/credentials' as const;
export const UpdateIntegrationCredentialsMethod = 'POST' as const;
export const getUpdateIntegrationCredentialsUrl = (params: UpdateIntegrationCredentialsPathParameters) =>
    UpdateIntegrationCredentialsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateIntegrationCredentialsPathParameters) => String(params[param])
    );
